import React from "react";
import { connect } from 'react-redux';
import Select from 'react-select';
import { Actions as COMPANYACTIONS } from '../../../store/actions/companyActions';
import { Actions as LEAVEACTIONS } from '../../../store/actions/leaveActions';
import _ from 'lodash';
import { NotificationManager } from 'react-notifications';
import RulePart from "./RulePart";

import { v4 as uuidv4 } from 'uuid';

const Rule = ({ 
  rule, 
  selectOptions, 
  updateRule, 
  index, 
  disabled, 
  }) => {

    const condition = rule?.rules?.condition;
  
    console.log('selectedOption', rule.allowance, _.find(selectOptions, { value: rule.allowance }))
  
    const updateAllowance = (selectedOption) => {
      const updatedRule = { ...rule }
  
      updatedRule.allowance = selectedOption.value;
  
      updateRule(updatedRule);
    }
  
    const updateRuleCondition = (condition) => {
      const updatedRule = { ...rule }
  
      updatedRule.rules.condition = condition.value;
  
      updateRule(updatedRule);
    }
  
  
    const updateRulePart = (index, rulePart) => {
  
      console.log('rulePart', index, rulePart)
  
      const updatedRule = { ...rule }
  
      updatedRule.rules.parts[index] = rulePart;
  
      updateRule(updatedRule);
    }
  
    const removeRulePart = (index) => {
  
      console.log('rulePart', index)
  
      const updatedRule = { ...rule }
  
      if (updatedRule.rules.parts.length == 1 || index == 0 && updatedRule.rules.parts[1].id != null) {
        return NotificationManager.error('You cannot delete this rule!', 'Rules')
        return;
      }
  
      updatedRule.rules.parts.splice(index, 1)
      updateRule(updatedRule);
    }
  
    const addRulePart = (index) => {
  
      console.log('AddRulePart', index)
  
      const updatedRule = { ...rule }
  
      updatedRule.rules.parts.splice(index + 1, 0, {})
  
      console.log('prevRule', rule)
      console.log('newRule', updatedRule)
  
      updateRule(updatedRule);
    }
  
    const addCompositeRulePart = (index) => {
  
      console.log('AddRulePart', index)
  
      const updatedRule = { ...rule }
  
      updatedRule.rules.parts.splice(index + 1, 0, {
        id: uuidv4(),
        "condition": condition == 2 ? 3 : 2,
        "parts": [{
          id: uuidv4()
        }]
      })
  
      console.log('prevRule', rule)
      console.log('newRule', updatedRule)
  
      updateRule(updatedRule);
    }
  
    return (
      <div className="col-xs-12" style={{ paddingBottom: '2rem' }}>
        <h5>Rule {index + 1}</h5>
        <div className="col-xs-12">
          <label>Overtime / Allowance</label>
  
          <Select
            id="overtime-allowance-dropdown"
            value={_.find(selectOptions, { value: rule.allowance })}
            options={selectOptions}
            isDisabled={disabled}
            onChange={updateAllowance}
          />
          <div className="clearfix" />
        </div>
  
        <div>
          {rule.rules?.parts?.map?.((rulePart, index) => (
            <React.Fragment>
              <RulePart level="0" part={rulePart} withLabels={index == 0} condition={condition} updateRuleCondition={updateRuleCondition} updateRulePart={updateRulePart} index={index} key={rulePart.id} removeRulePart={removeRulePart} addRulePart={addRulePart} addCompositeRulePart={addCompositeRulePart} />
              <div className="clearfix" />
            </React.Fragment>
          ))}
        </div>
  
        {/*<AddNewRuleBottom rules={rule.rules}/>*/}
      </div>
    )
  
  }  

const mapStateToProps = (state) => {

    const allowanceOvertimeOptions = []
  
    state.company?.settings?.overtimes?.map(o => {
      allowanceOvertimeOptions.push({
        value: o.id,
        label: o.name
      })
    })
    state.company?.settings?.allowances?.map(o => {
      allowanceOvertimeOptions.push({
        value: o.id,
        label: o.name
      })
    })
  
    const leaveTypes = state.leave?.leaveTypes?.map(o => {
      return {
        value: o.id,
        label: o.name
      }
    })
  
    return {
      currentOrg: state.company?.settings?.org,
      allowanceOvertimeOptions,
      allowances: state.company?.settings?.allowances,
      overtime: state.company?.settings?.overtimes,
      departments: state.company?.settings?.departments,
      leaveTypes: leaveTypes,
      isDemo: state.company?.settings?.isDemo,
      organisationDetails: state.company?.settings,
      disabled: (state?.permissions?.my?.permissions?.settings == 'Read') || (state?.company?.settings?.status == 'Archived'),
      jurisdiction: state.company?.settings?.jurisdiction,
    }
  }
  
  const mapDispatchToProps = (dispatch) => ({
    updateSetting: (field, newValue) => dispatch(COMPANYACTIONS.updateSetting(field, newValue, false)),
    updateCompanyDetails: (body) => dispatch(COMPANYACTIONS.updateCompanyDetails(body)),
    getLeaveTypes: () => dispatch(LEAVEACTIONS.getLeaveTypes()),
  });
  
  export default connect(mapStateToProps, mapDispatchToProps)(Rule);
  